import { FortressProperties } from './fortress.properties.model';

export const properties: FortressProperties = {
  cdn: {
    baseUrl: 'https://static.apps.psu.edu/',
  },
  environmentLabel: 'Development',
  featureFlags: {},
  fortress: {
    activatedRoles: [],
    url: 'https://develop-fortress-service.qa.k8s.psu.edu/fortress-service-web/resources/',
  },
  oauth: {
    clientId: 'd732506b-6540-4759-8ace-ec4d63bb5ba3',
    discoveryDocumentUrl: 'https://develop-hydra-auth-server.qa.k8s.psu.edu/.well-known/openid-configuration',
    issuer: 'https://develop-oauth2-server.qa.k8s.psu.edu/',
    preserveRequestedRoute: true,
    redirectUri: 'https://fortress.development.apps.psu.edu',
    responseType: 'code',
    scope: 'openid offline_access',
    showDebugInformation: true,
    strictDiscoveryDocumentValidation: false,
  },
  searchService: {
    url: 'https://develop-search-service.qa.k8s.psu.edu/search-service/resources/',
  },
  production: false,
};
